import { initializeApp } from 'firebase/app';
import 'firebase/analytics';
import 'firebase/compat/auth';
const key = (process.env.NEXT_PUBLIC_RUN_ENV || 'development') as 'production' | 'staging' | 'development' | 'test';
export const firebaseConfig = {
  production: {
    apiKey: 'AIzaSyBoUR0eZK6z1GA1-R_vBVoiUCXbSAOVLDU',
    authDomain: 'farmai.firebaseapp.com',
    databaseURL: 'https://farmai.firebaseio.com',
    projectId: 'farmai',
    storageBucket: 'farmai.appspot.com',
    messagingSenderId: '158833016360',
    appId: '1:158833016360:web:74020acccdb3078f51bf1d',
    measurementId: 'G-YS73JY4T3D'
  },
  staging: {
    apiKey: 'AIzaSyA0Zotu0xhnhK1Fcn3hw7bRGyIwa6J02QA',
    authDomain: 'farmai-stg.firebaseapp.com',
    databaseURL: 'https://farmai-stg.firebaseio.com',
    projectId: 'farmai-stg',
    storageBucket: 'farmai-stg.appspot.com',
    messagingSenderId: '587843903950',
    appId: '1:587843903950:web:b1a9c3c82f4d3e3cda4b9f',
    measurementId: 'G-6P8G52FLCE'
  },
  development: {
    apiKey: 'AIzaSyA0Zotu0xhnhK1Fcn3hw7bRGyIwa6J02QA',
    authDomain: 'farmai-stg.firebaseapp.com',
    databaseURL: 'https://farmai-stg.firebaseio.com',
    projectId: 'farmai-stg',
    storageBucket: 'farmai-stg.appspot.com',
    messagingSenderId: '587843903950',
    appId: '1:587843903950:web:b1a9c3c82f4d3e3cda4b9f',
    measurementId: 'G-6P8G52FLCE'
  },
  test: {
    apiKey: 'AIzaSyA0Zotu0xhnhK1Fcn3hw7bRGyIwa6J02QA',
    authDomain: 'farmai-stg.firebaseapp.com',
    databaseURL: 'https://farmai-stg.firebaseio.com',
    projectId: 'farmai-stg',
    storageBucket: 'farmai-stg.appspot.com',
    messagingSenderId: '587843903950',
    appId: '1:587843903950:web:b1a9c3c82f4d3e3cda4b9f',
    measurementId: 'G-6P8G52FLCE'
  }
}[key];
export const app = initializeApp(firebaseConfig);